import { render, staticRenderFns } from "./LoginBice.vue?vue&type=template&id=44ed6ac5&scoped=true"
import script from "./LoginBice.vue?vue&type=script&lang=js"
export * from "./LoginBice.vue?vue&type=script&lang=js"
import style0 from "./LoginBice.vue?vue&type=style&index=0&id=44ed6ac5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed6ac5",
  null
  
)

export default component.exports